<template>
    <div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>调拨单号：</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="transVoucherInfo.innerNo"></el-input>
                    <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" v-if="selectVoucher" @click="selectTransVoucherInfoDlg"></div>
                </div>
            </div>
            <div class="form-group center" v-if="transVoucherInfo.srcVoucherType != null">
                <div class="form-label">
                    <label>来源单据号</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.srcVoucherInnerNo }}</span>
                </div>
            </div>
            <!--<div class="form-group center">-->
            <!--<div class="form-label">-->
            <!--<label>外部单据号</label>-->
            <!--</div>-->
            <!--<div class="form-value">-->
            <!--<span>{{transVoucherInfo.outerNo || "无"}}</span>-->
            <!--</div>-->
            <!--</div>-->
            <div class="form-group">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.memo || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调拨总数量</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.totalQuantity }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调拨总金额</label>
                </div>
                <div class="form-value">
                    <span>{{ parseFloat(transVoucherInfo.totalNetWorth || 0).toFixed(2) }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>调出机构</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.srcComFullName }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调出机构编码</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.srcBizUnitCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调出成本中心</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.srcCostCenterCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调出利润中心</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.srcPrftCenterCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>调入机构</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.dstComFullName }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调入机构编码</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.dstBizUnitCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调入成本中心</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.dstCostCenterCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调入利润中心</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.dstPrftCenterCode || '无' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>调拨日期</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.createTime || '无' }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="principalId != null && !transVoucherInfo.crossFlag">
                <div class="form-label">
                    <label></label>
                </div>
                <div class="form-value">
                    <el-checkbox v-model="autoReceive">机构负责人自动领用</el-checkbox>
                </div>
            </div>
        </div>
        <div class="simple-row" v-if="splittedReceipt">
            <div class="left">
                <el-button type="primary" @click="selectDevice()">选择调拨项</el-button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="deviceItemList" maxHeight="500" border tooltip-effect="dark" style="width: 100%">
                <el-table-column align="left" prop="innerCode" min-width="250" label="资产编号" fixed show-overflow-tooltip></el-table-column>
                <el-table-column prop="assetType" width="100" label="管理方式" align="center" fixed>
                    <template slot-scope="rows">
                        <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="title" label="资产描述全称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="fixedSpec" label="规格" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="transQuantity" label="调拨数量" width="80" align="right"></el-table-column>
                <el-table-column align="right" prop="directQuantity" width="100" label="已退还数量"></el-table-column>
                <el-table-column align="right" prop="receiptQuantity" width="100" label="已验收数量"></el-table-column>
                <el-table-column align="right" prop="quantity" label="验收数量" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.assetType == commonDevcVal || !scope.row.splitFlag">{{ scope.row.quantity }}</span>
                        <el-input type="number" :disabled="scope.row.splitible" min="0" class="input-content-right" @change="transAvQuantityChange(scope);" v-model.number="scope.row.quantity" v-else></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="theUnit" label="单位" width="60"></el-table-column>
                <el-table-column align="right" prop="orgWorth" width="80" label="原值(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.orgWorth != null">{{ rows.row.orgWorth.toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="netWorth" width="80" label="净值(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.netWorth != null">{{ rows.row.netWorth.toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="aggtDeprWorth" width="80" label="累计折旧(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.aggtDeprWorth != null">{{ rows.row.aggtDeprWorth.toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="调入部门全称" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span align="left" v-if="scope.row.dstComFullName != null">{{ scope.row.dstComFullName }}</span>
                        <a class="swb-btn-link" align="right" v-if="orgType == 1" @click="selectDstComName(scope.$index, false)">选择部门</a>
                    </template>
                </el-table-column>
                <el-table-column prop="dstWarehouseName" label="调入仓库" width="140" align="center" v-if="showBizUnitWarehouse">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.dstWarehouseId" placeholder="请选择" @change="selectDstWarehouse(scope.$index, false)">
                            <el-option v-for="item in wareHouseInList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="dstComNo" label="调入机构编号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dstCostCenterCode" label="调入成本中心" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="srcComFullName" label="调出部门全称" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="srcRealComCode" label="调出公司编码" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="srcCostCenterCode" label="调出成本中心" width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="taxRate" label="税率(%)" width="140" align="right" v-if="normalFlag">
                    <template slot-scope="scope">
                        <span>{{ scope.row.taxRate }}</span>
                        <!--<el-select v-model="scope.row.taxRate" placeholder="请选择税率">-->
                        <!--<el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>-->
                        <!--</el-select>-->
                    </template>
                </el-table-column>
                <el-table-column prop="ntxPrice" label="未税价(元)" width="140" align="right">
                    <template slot-scope="scope">
                            <span v-if="scope.row.dealingFlag">
                                <el-input type="number" class="width-2x" @blur="changeNtxPrice" v-model="scope.row.ntxPrice"></el-input>
                            </span>
                        <span v-else>{{ scope.row.ntxPrice }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { getDefaultPageSizes } from '../../app.conf'
import { openShopDeviceTransVoucherItemSelectDlg, openShopDeviceTransVoucherReceiptSaveDlg, openShopDeviceTransVoucherSelectDlg } from './showDetailDlg'
import { openBizDepartDlg } from '../orgStruct/selectDlg'
import { getMerchantBizParam } from '../asset/assetMain'

import assetVchrApi from '../../api/assetVchr'
import shopStockApi from '../../api/shopStock'
import retailerApi from '../../api/retailer'
import fiscalBizApi from '../../api/fiscalBiz'

export default {
    name: 'swb-trans-receipt-save',
    avlActions: '',
    avlScopes: 'vendor',
    notAsResc: true,
    authen: false,
    desc: '调拨单验收-详情',
    props: ['id', 'bizUnitId', 'selectVoucher'],
    data: function () {
        return {
            //
            transVoucherInfo: {},
            deviceItemList: [],
            warehouseId: null,
            warehouseName: null,
            comInfo: null,
            comId: null,
            comName: null,
            orgType: null,
            //
            acctEnterWayMap: {},
            dstBizUnitId: null,
            principalId: null,
            autoReceive: false,
            normalFlag: false,
            fiscalTaxMarkList: [],
            splittedReceipt: false, // 是否允许多次验收
            showBizUnitWarehouse: false,
            assetTypeMap: getEnumMap('assetType', 'value2text'),
            commonDevcVal: getEnumInfoWith('assetType', 'name', 'CommonDevc').value,
            durableDevcVal: getEnumInfoWith('assetType', 'name', 'DurableDevc').value,
            onlyDepartReceipt: false
        }
    },
    created: function () {
        let self = this;
        getMerchantBizParam('allot.allow.splitted.receipt', function (result) {
            self.splittedReceipt = Utils.isTrue(result);
        });
        getMerchantBizParam('show.biz.unit.warehouse', function (result) { // 显示门店/机构的仓库： {}
            self.showBizUnitWarehouse = Utils.isTrue(result);
        });
        getMerchantBizParam('allot.only.allow.receipt.by.dest.depart', function (result) {
            self.onlyDepartReceipt = Utils.isTrue(result);
        }, 0);
        this.acctEnterWayMap = getEnumMap('acctEnterWay', 'value2text');
        if(!Utils.isNoB(this.id)) {
            this.getShopDeviceTransVoucher(this.id);
        }
        this.getRetailerCom();
        this.getFiscalTaxMarkList();
    },
    methods: {
        getFiscalTaxMarkList: function () {
            let self = this;
            let postData = {};
            postData.disabled = false;
            postData.type = getEnumInfoWith('taxType', 'name', 'JXS').value;
            //
            let theLoad = MsgBox.loading();
            fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    let fiscalTaxMarkList = result.data || [];
                    if(fiscalTaxMarkList.length > 0) {
                        fiscalTaxMarkList.forEach(function (item) {
                            item.rate = parseFloat(item.rate).toFixed(2);
                        });
                    }
                    self.fiscalTaxMarkList = fiscalTaxMarkList;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getRetailerCom() {
            let self = this;
            retailerApi.getRetailerCom({}, function (result) {
                if(result.type == 'info') {
                    self.comInfo = result.data;
                    self.principalId = result.data.principalId;
                    self.comId = result.data.bizUnitId;
                    self.comName = result.data.bizUnitName;
                    self.orgType = result.data.orgType;
                }
            });
        },
        // 金额校验
        changeNtxPrice: function () {

        },
        // 数量变化校验
        transAvQuantityChange: function (scope) {
            let items = this.deviceItemList || [];
            items.forEach(function (item) {
                if(item.transVoucherItemId == scope.row.transVoucherItemId) {
                    if(item.quantity < 0) {
                        Toast.show('数量不可小于0');
                        return;
                    }
                    let receiptAbleQuantity = (item.transQuantity - item.directQuantity - item.receiptQuantity) || 0;
                    if(receiptAbleQuantity < item.quantity) {
                        Toast.show('当前验收数量' + item.quantity + '，大于可验收数量：' + receiptAbleQuantity, 2000, 'info');
                        return;
                    }
                    // 根据验收数量计算原值、净值、累计折旧
                    if(receiptAbleQuantity == item.quantity) {
                        item.orgWorth = item.orgWorthX;
                        item.netWorth = item.netWorthX;
                        item.aggtDeprWorth = item.aggtDeprWorthX;
                    } else if(receiptAbleQuantity > item.quantity) {
                        let quantityBili = item.quantity / receiptAbleQuantity;
                        item.orgWorth = parseFloat(parseFloat(item.orgWorthX * quantityBili).toFixed(2));
                        item.netWorth = parseFloat(parseFloat(item.netWorthX * quantityBili).toFixed(2));
                        item.aggtDeprWorth = parseFloat(parseFloat(item.aggtDeprWorthX * quantityBili).toFixed(2));
                    }
                }
            });
        },
        getAllotAcntType: function (item, callBack) {
            let theLoad = MsgBox.loading();
            let postData = {
                dstComId: item.dstComId,
                srcComId: item.srcComId
            };
            assetVchrApi.getShopDeviceTransVoucherAllotAcntType(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    //
                    callBack(result.data)
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        selectTransVoucherInfoDlg: function () {
            let self = this;
            let params = {
                bizUnitId: self.bizUnitId
            };
            if(self.onlyDepartReceipt) {
                params.dstComId = self.comInfo.id;
            }
            params.fiscalAcctFlag = true;  // 资产调拨单
            openShopDeviceTransVoucherSelectDlg(params, function (result, theDlg) {
                theDlg.close();
                self.id = result.id;
                self.getShopDeviceTransVoucher(result.id);
            });
        },
        getShopDeviceTransVoucher: function (id) {
            let self = this;
            let postData = {};
            postData.id = id;
            let theLoading = MsgBox.loading();
            assetVchrApi.getShopDeviceTransVoucher(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    let transVoucherInfo = result.data;
                    self.checkReturnState(id, (warnFlag) => {
                        if(warnFlag) {
                            MsgBox.warning('提示内容：当前调拨单【' + transVoucherInfo.innerNo + '】存在未确认的退还单，请确认后再进行操作');
                        } else {
                            self.dstBizUnitId = transVoucherInfo.dstBizUnitId;
                            self.transVoucherInfo = transVoucherInfo;
                            //
                            self.getWarehouseList(transVoucherInfo.dstBizUnitId);
                            self.getReceiptItems(transVoucherInfo.id);
                            getMerchantBizParam('asset.finac.enabled', function (normalFlagResult) {
                                self.normalFlag = Utils.isTrue(normalFlagResult);
                            }, 2, transVoucherInfo.dstBizUnitId);
                        }
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        checkReturnState: function (deriveId, callbackFunc) {
            let filterItems = {};
            filterItems.deriveId = deriveId;
            filterItems.directFlag = -1;
            filterItems.fiscalAcctFlag = true;  // 资产退换单
            filterItems.confirmState = 0;
            let theLoad = MsgBox.loading();
            assetVchrApi.getShopDeviceTransVoucherNoPageList(filterItems, (result) => {
                theLoad.hide();
                if(result.type === 'info') {
                    callbackFunc((result.data || []).length > 0);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 获取调拨需要验收的条目
        getReceiptItems: function (transVoucherId) {
            let self = this;
            let postData = {};
            postData.voucherId = transVoucherId;
            assetVchrApi.getShopDeviceTransVoucherItemAutoList(postData, function (result) {
                if(result.type == 'info') {
                    let deviceItemList = result.data || [];

                    // 查询已验收、已退还的数量
                    self.getTransReceiptOrDirectQuantity(function (resultData) {
                        let receiptQuantityMap = resultData.receiptQuantityMap || {};
                        let directQuantityMap = resultData.directQuantityMap || {};
                        //
                        let newDeviceItemList = [];
                        if(deviceItemList.length > 0) {
                            deviceItemList.forEach(function (item) {
                                let receiptQuantity = 0;
                                if(!Utils.isNoB(receiptQuantityMap) && receiptQuantityMap[item.id] != null) { // 已验收
                                    receiptQuantity = receiptQuantityMap[item.id];
                                }
                                let directQuantity = 0;
                                if(!Utils.isNoB(directQuantityMap) && directQuantityMap[item.id] != null) { // 已退还
                                    directQuantity = directQuantityMap[item.id];
                                }
                                item.receiptQuantity = receiptQuantity;
                                item.directQuantity = directQuantity;
                                //
                                if(receiptQuantity + directQuantity < item.quantity) {
                                    newDeviceItemList.push(item);
                                }
                            })
                        }
                        //
                        if(newDeviceItemList.length > 0) {
                            self.setDeviceItemList(newDeviceItemList);
                        }
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getTransReceiptOrDirectQuantity: function (callBack) {
            let self = this;
            let postData = {
                transVoucherId: self.id
            };
            let theLoad = MsgBox.loading();
            assetVchrApi.getTransReceiptOrDirectQuantity(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    callBack(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 仓库信息
        getWarehouseList: function (dstBizUnitId) {
            let self = this;
            let postData = {};
            let filterItems = {};
            filterItems.retailerShopId = dstBizUnitId;
            filterItems.locked = false;
            postData.filterItems = filterItems;
            let theLoad = MsgBox.loading();
            shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    let wareHouseInList = result.data;
                    wareHouseInList.forEach(function (row) {
                        if(row.defaulted == true) {
                            self.warehouseId = row.id;
                            self.warehouseName = row.name;
                        }
                    });
                    self.wareHouseInList = wareHouseInList;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 选择调拨项
        selectDevice: function () {
            let self = this;
            let id = self.id;
            if(Utils.isNoB(id)) {
                MsgBox.warning('请选择调拨单');
                return;
            }
            let selectIds = self.deviceItemList.pluck('transVoucherItemId') || [];
            openShopDeviceTransVoucherItemSelectDlg(id, selectIds, function (result) {
                let deviceItems = result || [];
                //
                if(deviceItems.length > 0) {
                    self.setDeviceItemList(deviceItems);
                }
            })
        },
        // 组装单品式管理
        setDeviceItemList(deviceItems) {
            let self = this;
            let deviceItemList = [];
            deviceItems.forEach(function (item) {
                let receiptAssetItem = {};
                receiptAssetItem.transVoucherItemId = item.id;
                receiptAssetItem.transVoucherId = item.voucherId;
                receiptAssetItem.assetType = item.assetType;
                receiptAssetItem.durable = Utils.isTrue(item.assetType == self.durableDevcVal);
                receiptAssetItem.srcComId = item.srcComId;
                receiptAssetItem.srcComNo = item.srcComNo;
                receiptAssetItem.srcComName = item.srcComName;
                receiptAssetItem.srcComFullName = item.srcComFullName;
                receiptAssetItem.srcRealComCode = item.srcRealComCode;
                receiptAssetItem.srcCostCenterCode = item.srcCostCenterCode;
                receiptAssetItem.srcWarehouseId = item.srcWarehouseId;
                receiptAssetItem.srcWarehouseName = item.srcWarehouseName;
                receiptAssetItem.fiscalAcctFlag = item.fiscalAcctFlag;
                receiptAssetItem.allotAcntMethod = item.allotAcntMethod;
                receiptAssetItem.acctEnterWay = item.acctEnterWay;
                receiptAssetItem.deviceXId = item.deviceXId;
                receiptAssetItem.defId = item.devcDefId;
                receiptAssetItem.tmpNo = item.tmpNo;
                receiptAssetItem.catName = item.catName;
                receiptAssetItem.catId = item.catId;
                receiptAssetItem.brandName = item.brandName;
                receiptAssetItem.innerDevcCatName = item.innerDevcCatName;
                receiptAssetItem.theUnit = item.theUnit;
                receiptAssetItem.title = item.title;
                receiptAssetItem.name = item.name;
                receiptAssetItem.model = item.model;
                receiptAssetItem.fixedSpec = item.fixedSpec;
                receiptAssetItem.innerCode = item.innerCode;
                receiptAssetItem.assetKindName = item.assetKindName;
                receiptAssetItem.orgWorth = item.orgWorth2;
                receiptAssetItem.orgWorthX = item.orgWorth2;
                receiptAssetItem.netWorth = item.netWorth2;
                receiptAssetItem.netWorthX = item.netWorth2;
                receiptAssetItem.aggtDeprWorth = item.aggtDeprWorth2;
                receiptAssetItem.aggtDeprWorthX = item.aggtDeprWorth2;
                receiptAssetItem.suitName = item.suitName;
                receiptAssetItem.dstWarehouseId = item.dstWarehouseId != null ? item.dstWarehouseId : self.warehouseId;
                receiptAssetItem.dstWarehouseName = item.dstWarehouseName != null ? item.dstWarehouseName : self.warehouseName;
                receiptAssetItem.dstComId = item.dstComId != null ? item.dstComId : self.comId;
                receiptAssetItem.dstComNo = item.dstComNo;
                receiptAssetItem.dstComName = item.dstComName != null ? item.dstComName : self.comName;
                receiptAssetItem.dstComFullName = item.dstComFullName != null ? item.dstComFullName : self.comInfo.fullName;
                receiptAssetItem.dstCostCenterCode = item.dstCostCenterCode;
                receiptAssetItem.srcRealComCode = item.srcRealComCode;
                receiptAssetItem.dstRealComCode = item.dstRealComCode;
                receiptAssetItem.dealingFlag = item.dealingFlag;
                receiptAssetItem.ntxPrice = item.assetNature == 1 ? (item.netWorth == null ? 0.00 : item.netWorth) : item.orgWorth2;  // 调出方：资产 净值 作为 未税价，可修改（低值易耗为调出方净值的一半，也就是调入方原值）
                receiptAssetItem.transQuantity = item.quantity;
                receiptAssetItem.directQuantity = item.directQuantity; // 已退还
                receiptAssetItem.receiptQuantity = item.receiptQuantity;// 已验收
                if(Utils.isTrue(item.assetType == self.durableDevcVal)) {
                    let checkAvaliableQuantity = (item.quantity || 0) - (item.directQuantity || 0) - (item.receiptQuantity || 0); // 当前可验收数量
                    checkAvaliableQuantity = Utils.isTrue(checkAvaliableQuantity < 0) ? 0 : checkAvaliableQuantity;
                    receiptAssetItem.quantity = checkAvaliableQuantity; // 当前可验收数量
                } else {
                    receiptAssetItem.quantity = 1;
                }
                receiptAssetItem.splitible = item.splitible;
                receiptAssetItem.splitFlag = item.splitFlag;
                receiptAssetItem.taxRate = item.taxRate;
                deviceItemList.push(receiptAssetItem);
            });
            this.deviceItemList = Utils.merge([], deviceItemList);
        },
        selectDstComName: function (rowIndex, durable) {
            let self = this;
            let deviceItemList = self.deviceItemList || [];
            let item = deviceItemList[rowIndex];
            openBizDepartDlg(self.dstBizUnitId, function (result) {
                item.dstComId = result.id;
                item.dstComNo = result.no;
                item.dstComName = result.name;
                item.dstComFullName = result.fullName;
                item.dstCostCenterCode = result.costCenterCode;
                if(item.dstComId == item.srcComId && item.dstWarehouseId == item.srcWarehouseId) {
                    MsgBox.warning('调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨');
                    return false;
                }
                self.getAllotAcntType(item, function (result) {
                    item.allotAcntType = result;
                    self.deviceItemList = Utils.merge([], deviceItemList);
                });
            }, '调入部门 - 选择', true)
        },
        selectDstWarehouse(rowIndex, durable) {
            let self = this;
            let deviceItemList = self.deviceItemList || [];
            let item = deviceItemList[rowIndex];
            if(item.srcWarehouseId == item.dstWarehouseId && item.srcComId == item.dstComId) {
                MsgBox.warning('调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨');
                return false;
            } else {

                let dstWarehouseId = item.dstWarehouseId;
                let wareHouseInList = this.wareHouseInList;
                let wareHouse = wareHouseInList.find(function (item) {
                    return item.id == dstWarehouseId;
                });
                item.dstWarehouseName = wareHouse.name;
                this.deviceItemList = Utils.merge([], deviceItemList);
            }
        },
        getDlgResult: function () {
            let result = {};
            result.type = 'info';
            // ---------
            let itemList = this.deviceItemList || [];
            if(itemList.length > 0) {
                let submitFlag = true;
                let message = null;
                itemList.forEach(function (item) {
                    if(Utils.isTrue(item.durable)) {
                        if(Utils.isNoB(item.quantity) || item.quantity <= 0) {
                            message = item.title + '当前验收数量必须大于0';
                            submitFlag = false;
                        }
                        if((item.transQuantity - item.directQuantity - item.receiptQuantity) < item.quantity) {
                            message = item.title + '当前验收数量' + item.quantity + '，大于可验收数量：' + (item.transQuantity - item.directQuantity - item.receiptQuantity);
                            submitFlag = false;
                        }
                    }
                    if(Utils.isNoB(item.dstComId)) {
                        message = '调入部门不能为空，不可调拨';
                        submitFlag = false;
                    }
                    if(Utils.isNoB(item.dstWarehouseId)) {
                        message = '调入仓库不能为空，不可调拨';
                        submitFlag = false;
                    }
                    if(item.srcWarehouseId == item.dstWarehouseId && item.srcComId == item.dstComId) {
                        message = '调入部门和调出部门或者调入仓库与调出仓库相同，不可调拨';
                        submitFlag = false;
                    }
                });
                if(Utils.isTrue(submitFlag)) {
                    let transReceipt = {};
                    let transVoucherInfo = this.transVoucherInfo;
                    transReceipt.transVoucherId = transVoucherInfo.id;
                    transReceipt.transVoucherNo = transVoucherInfo.no;
                    transReceipt.autoReceive = this.autoReceive;
                    transReceipt.receiptAssetItemList = Utils.merge([], itemList);
                    result.data = transReceipt;
                } else {
                    result.type = 'warn';
                    result.message = message;
                }
            } else {
                result.type = 'warn';
                result.message = '请选择资产信息！';
            }
            return result;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherReceiptSave.vue